import { usePluginMessages, useSession } from '../../../composition/plugin-runtime';
import { login, logout } from '../composition/auth';

// 로그인 상태 — 머리말(app.header)이나 홈(home.main)에 놓인다. 버튼 하나라 어느 자리에서도 같은 모양이다
const BUTTON =
  'h-8 rounded-global-radius-8 px-global-spacing-12 text-label-xs-sb focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-outline-brand-primary-focused';

export function AuthWidget() {
  const t = usePluginMessages('auth');
  const session = useSession();
  return (
    <section aria-label={t('label')}>
      {session ? (
        <>
          {/* 머리말에는 버튼만 보이고, 로그인 상태는 화면 읽기 프로그램에 알린다 */}
          <p className="sr-only">{t('signedIn')}</p>
          <button type="button" onClick={logout} className={`${BUTTON} bg-bg-neutral-weak text-text-neutral-subtle hover:bg-bg-neutral-weak-hover`}>
          {t('logout')}
          </button>
        </>
      ) : (
        <button type="button" onClick={login} className={`${BUTTON} bg-bg-brand-primary-solid text-text-static-solid hover:bg-bg-brand-primary-solid-hover`}>
          {t('login')}
        </button>
      )}
    </section>
  );
}
